var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15586 11.3776L4.03607 7.5724L1.08398 5.01302L4.98398 4.67448L6.50065 1.08594L8.01732 4.67448L11.9173 5.01302L8.96523 7.5724L9.84544 11.3776L6.50065 9.3599L3.15586 11.3776Z",
    fill: "url(#paint0_linear_67_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_27",
    x1: 6.50065,
    y1: 1.08594,
    x2: 6.50065,
    y2: 11.3776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4AF38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.99b0afacfc2b250cbee1ba4448159f6c.svg";
export { ForwardRef as ReactComponent };